import React from "react";

const MurqueContainer = () => {
  const items = ["⚽", "🏀", "🏈", "🎾", "🏐"];

  return (
    <div className="murque_wrapper" aria-label="Sports marquee">
      <div className="murque">
        <div className="murque_track" role="list">
          {items.concat(items).map((t, i) => (
            <span key={i} className="murque_item" role="listitem">
              {t}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};

export default MurqueContainer;
